import React from 'react';

export const INIT_AGREE_DETAIL_DATA = {
  // 공통
  mallList: [
    {
      mallAccountId: '',
      mallName: '',
      mallSeq: 0,
      settlementBeginDate: '' || null,
      settlementEndDate: '' || null,
      sumScheduledSettlementAmt: 0 || null,
    },
  ],
  prejudgementTypeCd: '',
  businessName: '',
  financeInstitutionName: '',
  // case1: DEFAULT
  dataProvideAgreeSeq: 0,
  apiInterlockUrl: '' || null,
  businessRegistrationNumber: '',
  businessSeq: 0,
  creditGoodsMasterEventName: '',
  creditGoodsMasterEventSeq: 0,
  dataProvideStatus: '',
  dataProvideType: '',
  dataUseType: '',
  deepLink: '',
  endDt: '',
  financeInstitutionSeq: 0,
  inflowDt: '' || null,
  interlockKey: '',
  // case2: ADD_MALL
  dataUseAdditionRequestSeq: 0,
  code: '',

  stipulationList: [
    {
      essentialYn: '',
      stipulationBeginDate: '',
      stipulationCd: '',
      stipulationCdName: '',
      stipulationContents: '',
      stipulationSeq: 0,
      stipulationTypeCd: '',
    },
  ],
};

export const KEY_GUIDE = {
  SECURED: {
    JTC100: (
      <>
        <span className="keyGuideTitle">[주요 안내]</span>
        데이터 제공 동의 시, 동의한 판매몰의 담보 기간 내 정산 예정금은 해당
        금융기관에만 담보로 제공됩니다. 동의한 금융기관 외 다른 금융기관에는
        담보로 제공할 수 없으며, 대출 비교 서비스 이용 시에도 해당 기간의 정산
        예정금을 사용할 수 없습니다.
      </>
    ),
    JTC200: (
      <>
        <span className="keyGuideTitle">[주요 안내]</span>
        대출 서비스 이용을 위해 최근 1년간 매출 누적액이 금융기관에 제공됩니다.
        판매몰의 매출 데이터가 1년 미만인 경우, 월평균 매출액을 기준으로 1년치
        매출로 환산하여 계산됩니다. 데이터 제공 동의 시, 동의한 판매몰의 담보
        기간 내 발생되는 정산 예정금은 해당 금융기관에만 담보로 제공됩니다.
        동의한 금융기관 외 다른 금융기관에는 담보로 제공할 수 없으며, 대출 비교
        서비스 이용 시에도 해당 기간의 정산 예정금을 사용할 수 없습니다.
      </>
    ),
  },
  UNSECURED: {
    mall: (
      <>
        <span className="keyGuideTitle">[주요 안내]</span>
        데이터 제공 동의 시, 데이터 제공 기간 동안 판매몰의 매출 및 정산 정보
        등은 금융기관에 제공됩니다.
      </>
    ),
    none: ``,
  },
  ADD_MALL: [
    '데이터 제공 동의 시, 동의한 판매몰의 담보 기간 내 정산예정금은 타 금융기관에 담보로 제공할 수 없습니다.',
    '대출 비교 시, 해당 정산예정금은 사용 불가 합니다.',
    '정산예정금은 금융기관에서 요청한 시점의 데이터가 노출 되므로 현재 시점과 다를 수 있습니다.',
  ],
};

export const getOneBtnModalMessage = (data = {}) => {
  switch (data.code) {
    case 'RSC400':
      return `<p><span style="font-weight: 650">${data.businessName}</span> 고객님,<br/><span style="font-weight: 650">${data.financeInstitutionName}</span>의 대출 신청을 위한<br />데이터 제공 동의 가능일자가 만료되었습니다.<br /><br /><span style="font-weight: 650">${data.financeInstitutionName}</span>에 다시 한번 문의 부탁드립니다.</p>`;
    case 'RSC500':
      return `<p><span style="font-weight: 650">${data.businessName}</span> 고객님,<br/><span style="font-weight: 650">${data.financeInstitutionName}</span>의 대출 신청을 위한<br />데이터 이용이 종료되었습니다.<br /><br /><span style="font-weight: 650">${data.financeInstitutionName}</span>에 다시 한번 문의 부탁드립니다.</p>`;
  }
};

export const getNoBtnModalMessage = message => {
  if (message.includes('동의건이 없습니다')) {
    const memberName = message.split(' ')[0];
    return (
      <p>
        <span style={{ fontWeight: 'bold' }}>{memberName}</span>
        {message.replace(memberName, ' ')}
      </p>
    );
  } else {
    return message;
  }
};
